import { PlatformSlug } from 'constants/consts'
import { enabledOn, isFeatureAvailable } from 'platformConfig'

export const TOPIC_TABS_CONFIG = enabledOn(
  PlatformSlug.DATBooster,
  PlatformSlug.OATBooster,
  PlatformSlug.DATCrusher,
  PlatformSlug.PATBooster,
  PlatformSlug.INBDEBooster,
  PlatformSlug.NBDHEBooster,
  PlatformSlug.NDEBCrusher,
  PlatformSlug.GREBooster,
  PlatformSlug.NBEOPartOne,
  PlatformSlug.DLOSCE,
  PlatformSlug.MCATBooster
)

export const isTopicTabsAvailable = (slug?: PlatformSlug) => isFeatureAvailable(TOPIC_TABS_CONFIG, slug)
